module.exports = __webpack_public_path__ + "css/TryStar.1501b9db.css";